import React from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { toJS } from '../../containers/to-js';
import queryString from 'query-string';
import PropTypes from 'prop-types';
import { makePayment } from '../../actions/payment';
import client from '../../client';
import config from '../../config';
import { Redirect } from 'react-router-dom';
import qs from 'query-string';
import { ModelPropertiesParser } from '../commons/modelPropertiesParser';
import axios from 'axios';

const randomString = (length, chars) => {
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
}

class Payment extends React.Component {
    constructor(props, context) {
        super(props, context);
        const route = context.router.route;
        const params = queryString.parse(route.location.search);
        this.state = {
            orderId: randomString(16, '0123456789'),
            refundMessage: null,
            errorMessage: null,
            windowClosedMsg: null
            //nttdataStatus: null
        }
    }

    componentDidMount() {
        const { router: { history: { location: { search } } } } = this.context;
        //qs.parse(search);
    }

    makePayment = (payload) => {
        const { layoutItem: { itemProperties: { paymentConfig } } } = this.props;
        switch (paymentConfig.paymentProvider && paymentConfig.paymentProvider.value) {
            case 'CASHFREE': this.makeCashFreePayment(payload);
                break;
            case 'CCAVENUE': this.makeCCAvenuePayment(payload);
            case 'SQUAREUP': this.makeSquareUpPayment(payload);
            case 'NTTDATA': this.makeNttDataPayment(payload);
            case 'PAYU': this.makePayUPayment(payload);
                break;
            default: console.error("Payment provider is not set");
        }
    }

    makePayUPayment = (payload) => {
        const { layoutItem: { itemProperties: { paymentConfig } }, company } = this.props;
        const self = this;
        const payUEndPoint = paymentConfig.isTestEnvironment ? config.payuEndPointTest : config.payuEndPoint;
        const newPayload = {
            merchantId: paymentConfig.isTestEnvironment ? config.payuMerchantIdTest : config.payuMerchantId,
            payUEndPoint:payUEndPoint,
            surl: `${config.authAPI}/payment/payuResponse`,
            furl: `${config.authAPI}/payment/payuResponse`,
            isTestEnvironment: paymentConfig.isTestEnvironment,
            ...payload
        }
        
        client().post(`${config.authAPI}/payment/payuPayment`, newPayload).then((res) => {
            console.log('payment...', res)
            var windowHandle = window.open(`${res.data}`);
            window.callbacks = [];
            window.callbacks['paymentCallback' + payload.order_id] = function () {
                windowHandle.close();
            };
            var closeInterval;
            var closeFunc = function () {
                if (windowHandle && windowHandle.closed) {
                    self.setState({
                        windowClosedMsg: 'Validating Payment'
                    }, () => {
                        clearInterval(closeInterval);
                        client().post(`${config.authAPI}/payment/orderDetails`, {
                            orderId: payload.order_id
                        }).then((orderDetailsResponse) => {
                            orderDetailsResponse = orderDetailsResponse.data;
                            const actualSubmit = self.props.onHandleSubmit(values => {
                                let payload = values;
                                payload = values.set(paymentConfig.paymentStatusField, orderDetailsResponse.orderStatus);
                                payload = payload.set(paymentConfig.paymentReferenceField, orderDetailsResponse.orderId);
                                payload = payload.set(paymentConfig.bankRefField, orderDetailsResponse.bankReferenceNumber)
                                if (orderDetailsResponse.transactionDate) {
                                    payload = payload.set(paymentConfig.paymentDateField, orderDetailsResponse.transactionDate);
                                }
                                self.props.onSubmit(payload);
                            });
                            actualSubmit();
                        }).catch((er) => {
                            console.error(er);
                        });
                    })
                    
                }
            }
            closeInterval = setInterval(closeFunc, 500);

        }).catch((error) => {
            this.setState({errorMessage: "We are unable to reach payment provider, Please try again after some time.", orderId: randomString(16, '0123456789') })
            console.error(error);
        });
    }

    makeNttDataPayment = (payload) => {
        const { layoutItem: { itemProperties: { paymentConfig } } } = this.props;
        const newPayload = {
            orderId: this.state.orderId,
            description: payload.billingName,
            currencyCode: "INR",
            totalAmount: payload.amount,
            customerName: payload.billing_name,
            customerEmail: payload.billing_email,
            customerPhone: payload.billing_tel,
            origin: window.location.origin,
            // backWf: window.location.href.split('app/')[1]
        }
        const self = this;
        var windowHandle = window.open(`${window.location.origin}/processpayment`);
        localStorage.setItem('nttdataAuth', JSON.stringify(newPayload))

        // window.callbacks = [];
        // window.callbacks['paymentCallback' + payload.orderId] = function() {
        //     windowHandle.close();
        // };
        var closeInterval;
        var closeFunc = function () {
            if (windowHandle && windowHandle.closed) {
                console.log('close...')
                let oId = localStorage.getItem('nttdataTxnId')
                clearInterval(closeInterval);
                client().post(`${config.authAPI}/payment/orderDetails`, {
                    orderId: oId
                }).then((orderDetailsResponse) => {
                    orderDetailsResponse = orderDetailsResponse.data;
                    const actualSubmit = self.props.onHandleSubmit(values => {
                        let payload = values;
                        payload = values.set(paymentConfig.paymentStatusField, orderDetailsResponse.orderStatus);
                        payload = payload.set(paymentConfig.paymentReferenceField, orderDetailsResponse.orderId);
                        payload = payload.set(paymentConfig.bankRefField, orderDetailsResponse.bankReferenceNumber)
                        if (orderDetailsResponse.transactionDate) {
                            payload = payload.set(paymentConfig.paymentDateField, orderDetailsResponse.transactionDate);
                        }
                        self.props.onSubmit(payload);
                    });
                    actualSubmit();
                }).catch((er) => {
                    console.error(er);
                });
            }
        }
        closeInterval = setInterval(closeFunc, 500);


    }

    makeSquareUpPayment = (payload) => {
        const { layoutItem: { itemProperties: { paymentConfig } } } = this.props;
        const self = this;
        const newPayload = {
            orderId: this.state.orderId,
            redirectUrl: config.squareUpRedirectUrl,
            description: payload.billingName,
            currencyCode: payload.currency,
            totalAmount: payload.amount,
            customerName: payload.billing_name,
            customerEmail: payload.billing_email,
            customerPhone: payload.billing_tel,
            isTestMode: paymentConfig.isTestEnvironment
        }
        client().post(`${config.authAPI}/payment/getSquareupLink`, newPayload).then((res) => {
            var windowHandle = window.open(`${res.data.payment_link.url}`);
            window.callbacks = [];
            window.callbacks['paymentCallback' + payload.orderId] = function () {
                windowHandle.close();
            };
            var closeInterval;
            var closeFunc = function () {
                if (windowHandle && windowHandle.closed) {
                    clearInterval(closeInterval);
                    client().post(`${config.authAPI}/payment/orderDetails`, {
                        orderId: payload.order_id
                    }).then((orderDetailsResponse) => {
                        orderDetailsResponse = orderDetailsResponse.data;
                        const actualSubmit = self.props.onHandleSubmit(values => {
                            let payload = values;
                            payload = values.set(paymentConfig.paymentStatusField, orderDetailsResponse.orderStatus);
                            payload = payload.set(paymentConfig.paymentReferenceField, orderDetailsResponse.orderId);
                            if (orderDetailsResponse.transactionDate) {
                                payload = payload.set(paymentConfig.paymentDateField, orderDetailsResponse.transactionDate);
                            }
                            self.props.onSubmit(payload);
                        });
                        actualSubmit();
                    }).catch((er) => {
                        console.error(er);
                    });
                }
            }
            closeInterval = setInterval(closeFunc, 500);
        }).catch(error => {
            console.log('Payment Failed: ', error);
        })

    }

    makeCashFreePayment = (payload) => {
        const { layoutItem: { itemProperties: { paymentConfig } } } = this.props;
        const self = this;
        const newPayload = {
            orderId: this.state.orderId,
            redirectUrl: 'http://www.screenermonkey.com/app',
            description: payload.billingName,
            currencyCode: payload.currency,
            totalAmount: payload.amount,
            customerName: payload.billing_name,
            customerEmail: payload.billing_email,
            customerPhone: payload.billing_tel,
            isTestMode: paymentConfig.isTestEnvironment
        }
        client().post(`${config.authAPI}/payment/cashfree`, newPayload).then((res) => {
            console.log(res.data);
        }).catch(error => {
            console.log('Payment Failed: ', error);
        })
    }
    makeCCAvenuePayment = (payload) => {
        const { layoutItem: { itemProperties: { paymentConfig } }, company } = this.props;
        const self = this;
        //TODO: Get the payment URL from server
        const ccavHanlderEndPoint = paymentConfig.isTestEnvironment ? 'ccavTestRequestHandler' : 'ccavRequestHandler';
        client().post(`${config.authAPI}/payment/${ccavHanlderEndPoint}`, payload).then((res) => {
            let paymentURL = config.paymentAppUrl;
            if (company && company.companySettings && company.companySettings.ccavenuesettings) {
                const c = JSON.parse(company.companySettings.ccavenuesettings);
                paymentURL = c.paymentAppUrl ? c.paymentAppUrl : config.paymentAppUrl;
            }
            console.log(paymentURL);
            var windowHandle = window.open(`${paymentURL}?pay=${encodeURIComponent(res.data)}`);
            window.callbacks = [];
            window.callbacks['paymentCallback' + payload.order_id] = function () {
                windowHandle.close();
            };
            var closeInterval;
            var closeFunc = function () {
                if (windowHandle && windowHandle.closed) {
                    clearInterval(closeInterval);
                    client().post(`${config.authAPI}/payment/orderDetails`, {
                        orderId: payload.order_id
                    }).then((orderDetailsResponse) => {
                        orderDetailsResponse = orderDetailsResponse.data;
                        const actualSubmit = self.props.onHandleSubmit(values => {
                            let payload = values;
                            payload = values.set(paymentConfig.paymentStatusField, orderDetailsResponse.orderStatus);
                            payload = payload.set(paymentConfig.paymentReferenceField, orderDetailsResponse.orderId);
                            if (orderDetailsResponse.transactionDate) {
                                payload = payload.set(paymentConfig.paymentDateField, orderDetailsResponse.transactionDate);
                            }
                            self.props.onSubmit(payload);
                        });
                        actualSubmit();
                    }).catch((er) => {
                        console.error(er);
                    });
                }
            }
            closeInterval = setInterval(closeFunc, 500);
        }).catch((error) => {
            console.error(error);
        });
    }

    getRefund = (payload) => {
        const { layoutItem: { itemProperties: { paymentConfig } } } = this.props;
        switch (paymentConfig.paymentProvider && paymentConfig.paymentProvider.value) {
            case 'NTTDATA': this.getNttDataRefund(payload);
                break;
            case 'PAYU': this.getPayURefund(payload);
                break;
            default: console.error("Payment provider is not set");
        }
    }

    getNttDataRefund = (payload) => {
        const { layoutItem: { itemProperties: { paymentConfig } }, workflowData } = this.props;
        const amount = ModelPropertiesParser(`{{${paymentConfig.amountField}}}`, workflowData);
        const orderId = ModelPropertiesParser(`{{${paymentConfig.paymentReferenceField}}}`, workflowData)
        const atomTxnId = ModelPropertiesParser(`{{${paymentConfig.bankRefField}}}`, workflowData)
        const newPayload = {
            currencyCode: "INR",
            totalAmount: amount,
            orderId: orderId,
            atomTxnId: atomTxnId
        }
        client().post(`${config.authAPI}/payment/getRefund`, newPayload).then((res) => {
            const msg = res.data ? res.data.description : '';
            this.setState({ refundMessage: msg })

        }).catch(error => {
            console.log('Payment Failed: ', error);
        })
    }

    getPayURefund = (payload) => {
        const { layoutItem: { itemProperties: { paymentConfig } }, workflowData } = this.props;
        const amount = ModelPropertiesParser(`{{${paymentConfig.amountField}}}`, workflowData);
        const orderId = ModelPropertiesParser(`{{${paymentConfig.paymentReferenceField}}}`, workflowData)
        const mihpayuid = ModelPropertiesParser(`{{${paymentConfig.bankRefField}}}`, workflowData)
        const payURefund = paymentConfig.isTestEnvironment ? config.payURefundTest : config.payURefund;
        const newPayload = {
            currencyCode: "INR",
            totalAmount: amount,
            orderId: orderId,
            newOrderId: this.state.orderId,
            mihpayuid: mihpayuid,
            isTestEnvironment: paymentConfig.isTestEnvironment,
            payURefundUrl: payURefund,
            merchantId: paymentConfig.isTestEnvironment ? config.payuMerchantIdTest : config.payuMerchantId,
        }
        const self = this;
        client().post(`${config.authAPI}/payment/getPayuRefund`, newPayload).then((res) => {
            const msg = res.data ? res.data.msg : '';
            const status = res.data ? res.data.status : '';
            this.setState({ refundMessage: msg }, () => {
                if(status) {
                    const actualSubmit = this.props.onHandleSubmit(values => {
                        let payload = values;
                        payload = values.set(paymentConfig.paymentStatusField, status);
                        self.props.onSubmit(payload);
                    });
                    actualSubmit();
                }
            })

        }).catch(error => {
            console.log('Payment Failed: ', error);
        })
    }

    render() {
        const {
            layoutItem: {
                itemProperties: {
                    paymentConfig,
                    label
                }
            },
            amount,
            currency,
            billingName,
            billingAddress,
            billingCity,
            billingState,
            billingZip,
            billingCountry,
            billingTel,
            billingEmail,
            company,
            user
        } = this.props;
        if(this.state.payResp) {
            return <div dangerouslySetInnerHTML={{__html: this.state.payResp}}></div>
        }
        return (
            <div>
                {
                    (paymentConfig && paymentConfig.isRefund) && <Button name='refund'
                        onClick={() => {
                            this.getRefund();

                        }}
                        block
                        color='primary'
                    //disabled={!paymentConfig || !currency || !amount || !this.state.orderId}
                    >{(label && label.show ? label.text : 'Refund')}</Button>
                }
                {
                    this.state.refundMessage && <p className='mt-2'>{this.state.refundMessage}</p>
                }
                {
                    (paymentConfig && !paymentConfig.isRefund) && <Button name='payment'
                        onClick={() => {
                            const payload = {
                                order_id: this.state.orderId,
                                currency,
                                amount,
                                billing_name: billingName || company && company.name,
                                billing_address: billingAddress || 'NA',
                                billing_city: billingCity || 'NA',
                                billing_state: billingState || 'NA',
                                billing_zip: billingZip || 'NA',
                                billing_country: billingCountry || 'NA',
                                billing_tel: billingTel || '9876543210',
                                billing_email: billingEmail || (user && user.email) || `${company.name}@huwats.com`,
                                integration_type: 'iframe_normal'
                            }
                            this.makePayment(payload);
                            this.setState({ orderId: null });
                        }}
                        block
                        color='primary'
                        disabled={!paymentConfig || !currency || !amount || !this.state.orderId}
                    >{this.state.windowClosedMsg ? this.state.windowClosedMsg : (this.state.orderId ? (label && label.show ? label.text : 'Pay Now') : 'Complete payment to proceed...')}</Button>
                }
                {
                    this.state.errorMessage && <div className='payment-error-msg'>{this.state.errorMessage}</div>
                }
                
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const { layoutItem: { itemProperties: { paymentConfig } } } = ownProps;
    const currency = paymentConfig.currencyField && state.getIn(['form', ownProps.form, 'values', ...getAbsoluteField(paymentConfig.currencyField)]);
    return {
        currency: currency ? currency : "USD",
        billingName: paymentConfig.billingNameField && state.getIn(['form', ownProps.form, 'values', ...getAbsoluteField(paymentConfig.billingNameField)]),
        billingAddress: paymentConfig.billingAddressField && state.getIn(['form', ownProps.form, 'values', ...getAbsoluteField(paymentConfig.billingAddressField)]),
        billingCity: paymentConfig.billingCityField && state.getIn(['form', ownProps.form, 'values', ...getAbsoluteField(paymentConfig.billingCityField)]),
        billingState: paymentConfig.billingStateField && state.getIn(['form', ownProps.form, 'values', ...getAbsoluteField(paymentConfig.billingStateField)]),
        billingZip: paymentConfig.billingZipField && state.getIn(['form', ownProps.form, 'values', ...getAbsoluteField(paymentConfig.billingZipField)]),
        billingCountry: paymentConfig.billingCountryField && state.getIn(['form', ownProps.form, 'values', ...getAbsoluteField(paymentConfig.billingCountryField)]),
        billingTel: paymentConfig.billingTelField && state.getIn(['form', ownProps.form, 'values', ...getAbsoluteField(paymentConfig.billingTelField)]),
        billingEmail: paymentConfig.billingEmailField && state.getIn(['form', ownProps.form, 'values', ...getAbsoluteField(paymentConfig.billingEmailField)]),
        amount: paymentConfig.amountField && state.getIn(['form', ownProps.form, 'values', ...getAbsoluteField(paymentConfig.amountField)]),
        company: state.getIn(['company', 'details', 'data']),
        user: state.getIn(['user', 'user'])
    }
}

const getAbsoluteField = (fieldKey) => {

    return fieldKey ? fieldKey.split(".") : fieldKey;
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

Payment.contextTypes = {
    router: PropTypes.object
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(Payment));
